<div class="w-100" fxLayout="column">
    <ng-container *ngIf="(overdueOccasions?.controls?.length ?? 0) > 0">
        <div class="overdue-occasions-container" fxLayout="column" fxLayoutAlign="center start" fxLayoutGap="10px">
            <div class="overdue-occasions-header" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="5px">
                <mat-icon class="expansion-panel-icon">free_cancellation</mat-icon>
                <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="5px">
                    <!-- <span>{{ overdueOccasions.controls.length }}</span> -->
                    <span i18n="@@PreviousOccasions">Previous Occasions</span>
                </div>
                <mat-slide-toggle
                    class="ml-1"
                    matTooltip="Show past occasions"
                    i18n-matTooltip
                    (change)="showOverdueOccasions = !showOverdueOccasions"
                ></mat-slide-toggle>
            </div>
            <ng-container *ngIf="showOverdueOccasions">
                <div class="w-100" *ngFor="let occasion of overdueOccasions?.controls ?? []; let i = index">
                    <div class="index-number">{{ i + 1 }}</div>
                    <div fxLayout="column" [formGroup]="occasion | cast">
                        <div
                            class="date-row-wrapper"
                            fxFlex="100%"
                            fxLayout="row"
                            fxLayout.lt-md="column"
                            fxLayoutAlign="space-between center"
                            fxLayoutAlign.lt-md="center start"
                        >
                            <div class="date occ_start_date seats-available" fxLayoutAlign="start center">
                                <mat-form-field fxFlex="0 0 100%">
                                    <input
                                        matInput
                                        formControlName="start_date"
                                        [ngxMatDatetimePicker]="occstartDate"
                                        (focus)="occstartDate.open()"
                                        placeholder="Start date"
                                        i18n-placeholder="@@startDate"
                                    />
                                    <mat-datepicker-toggle matSuffix [for]="$any(occstartDate)"></mat-datepicker-toggle>
                                    <ngx-mat-datetime-picker closeOnDateSelect color="primary" #occstartDate>
                                        <ng-template>
                                            <span>Done</span>
                                        </ng-template>
                                    </ngx-mat-datetime-picker>
                                </mat-form-field>
                            </div>

                            <div class="date occ_end_date seats-available" fxLayoutAlign="start center">
                                <mat-form-field
                                    fxFlex="0 0 100%"
                                    matTooltip="Course occasion date period ends"
                                    i18n-matTooltip
                                >
                                    <input
                                        matInput
                                        formControlName="end_date"
                                        [ngxMatDatetimePicker]="occendDate"
                                        (focus)="occendDate.open()"
                                        placeholder="End date"
                                        i18n-placeholder="@@endDate"
                                        [min]="occasion.value.start_date"
                                    />
                                    <mat-datepicker-toggle matSuffix [for]="$any(occendDate)"></mat-datepicker-toggle>
                                    <ngx-mat-datetime-picker closeOnDateSelect color="primary" #occendDate>
                                        <ng-template>
                                            <span>Done</span>
                                        </ng-template>
                                    </ngx-mat-datetime-picker>
                                </mat-form-field>
                            </div>
                            <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="20px">
                                <mat-form-field class="total-seats-field">
                                    <input
                                        matInput
                                        fxLayoutAlign="end center"
                                        type="number"
                                        min="0"
                                        placeholder="Total seats"
                                        i18n-placeholder
                                        formControlName="total_seats"
                                    />
                                </mat-form-field>
                            </div>
                            <button
                                [disabled]="occasion.disabled"
                                class="add-date-btn"
                                color="primary"
                                mat-icon-button
                                matTooltip="Remove application period"
                                i18n-matTooltip
                            ></button>
                        </div>

                        <div
                            class="date-row-wrapper application-period w-100 seats-existed"
                            fxFlex="100%"
                            fxLayout="row"
                            fxLayout.lt-md="column"
                            fxLayoutAlign="space-between center"
                            fxLayoutAlign.lt-md="center start"
                        >
                            <div class="app-start-date date" fxFlex="0 0 45%" fxLayoutAlign="start center">
                                <mat-form-field fxFlex="0 0 100%">
                                    <input
                                        matInput
                                        formControlName="application_start_date"
                                        [ngxMatDatetimePicker]="applicationStartDate"
                                        (focus)="applicationStartDate.open()"
                                        placeholder="Enrollment/Registration start date"
                                        i18n-placeholder="@@enrollment/registrationStartDate"
                                        [max]="occasion.value.start_date"
                                    />
                                    <mat-datepicker-toggle
                                        matSuffix
                                        [for]="$any(applicationStartDate)"
                                    ></mat-datepicker-toggle>
                                    <ngx-mat-datetime-picker closeOnDateSelect color="primary" #applicationStartDate>
                                        <ng-template>
                                            <span>Done</span>
                                        </ng-template>
                                    </ngx-mat-datetime-picker>
                                </mat-form-field>
                            </div>

                            <div class="app-end-date date" fxFlex="0 0 45%" fxLayoutAlign="start center">
                                <mat-form-field fxFlex="0 0 100%">
                                    <input
                                        matInput
                                        formControlName="application_end_date"
                                        [ngxMatDatetimePicker]="applicationEndDate"
                                        (focus)="applicationEndDate.open()"
                                        placeholder="End date"
                                        i18n-placeholder="@@endDate"
                                        [min]="occasion.value.application_start_date"
                                        [max]="occasion.value.end_date"
                                    />
                                    <mat-datepicker-toggle
                                        matSuffix
                                        [for]="$any(applicationEndDate)"
                                    ></mat-datepicker-toggle>
                                    <ngx-mat-datetime-picker closeOnDateSelect color="primary" #applicationEndDate>
                                        <ng-template>
                                            <span>Done</span>
                                        </ng-template>
                                    </ngx-mat-datetime-picker>
                                </mat-form-field>
                            </div>
                            <div class="hide-visibility-btn" style="width: 115px"></div>
                            <button class="hide-visibility-btn add-date-btn" mat-icon-button>
                                <mat-icon class="material-icons-outlined">content_copy</mat-icon>
                            </button>
                        </div>
                    </div>
                </div>
                <div class="divider"></div>
            </ng-container>
        </div>
        <!-- <mat-expansion-panel [expanded]="false" #overdueOccasionsPanel class="expansion-panel">
        <mat-expansion-panel-header>
            <mat-icon class="expansion-panel-icon">free_cancellation</mat-icon>
            <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="5px">
                <span>{{ overdueOccasions.controls.length }}</span>
                <span i18n="@@OverdueOccasions">Overdue Occasions</span>
            </div>
        </mat-expansion-panel-header>
    </mat-expansion-panel> -->
    </ng-container>
    <ng-container *ngIf="(dateOccasions?.controls?.length ?? 0) > 0">
        <div *ngFor="let occasion of dateOccasions?.controls ?? []; let i = index">
            <ng-container *ngIf="!occasion.disabled">
                <div class="index-number">{{ i + 1 }}</div>
                <div fxLayout="column" [formGroup]="occasion | cast">
                    <div
                        class="date-row-wrapper w-100"
                        fxFlex="100%"
                        fxLayout="row"
                        fxLayout.lt-md="column"
                        fxLayoutAlign="space-between center"
                        fxLayoutAlign.lt-md="center start"
                    >
                        <div class="date occ_start_date" fxLayoutAlign="start center">
                            <mat-form-field fxFlex="0 0 100%">
                                <input
                                    matInput
                                    formControlName="start_date"
                                    [ngxMatDatetimePicker]="occstartDate"
                                    placeholder="Start date"
                                    i18n-placeholder="@@startDate"
                                    data-testid="admin-occasion-start-date"
                                />
                                <mat-datepicker-toggle matSuffix [for]="$any(occstartDate)"></mat-datepicker-toggle>
                                <ngx-mat-datetime-picker
                                    closeOnDateSelect
                                    [defaultTime]="[8, 0]"
                                    color="primary"
                                    #occstartDate
                                >
                                    <ng-template>
                                        <span>Done</span>
                                    </ng-template>
                                </ngx-mat-datetime-picker>
                            </mat-form-field>
                        </div>

                        <div class="date occ_end_date" fxLayoutAlign="start center">
                            <mat-form-field
                                fxFlex="0 0 100%"
                                matTooltip="Course occasion date period ends"
                                i18n-matTooltip
                            >
                                <input
                                    matInput
                                    formControlName="end_date"
                                    [ngxMatDatetimePicker]="occendDate"
                                    (focus)="occendDate.open()"
                                    placeholder="End date"
                                    i18n-placeholder="@@endDate"
                                    [min]="occasion.value.start_date"
                                    data-testid="admin-occasion-end-date"
                                />
                                <mat-datepicker-toggle matSuffix [for]="$any(occendDate)"></mat-datepicker-toggle>
                                <ngx-mat-datetime-picker
                                    closeOnDateSelect
                                    [defaultTime]="[17, 0]"
                                    color="primary"
                                    #occendDate
                                >
                                    <ng-template>
                                        <span>Done</span>
                                    </ng-template>
                                </ngx-mat-datetime-picker>
                            </mat-form-field>
                        </div>

                        <button
                            [disabled]="occasion.disabled"
                            class="add-date-btn"
                            color="primary"
                            mat-icon-button
                            (click)="removeDate(i)"
                            matTooltip="Remove occasion"
                            i18n-matTooltip
                        >
                            <mat-icon class="material-icons-outlined">do_not_disturb_on</mat-icon>
                        </button>
                    </div>

                    <div
                        class="date-row-wrapper application-period active-occasion w-100"
                        fxFlex="100%"
                        fxLayout="row"
                        fxLayout.lt-md="column"
                        fxLayoutAlign="start space-between"
                        fxLayoutAlign.lt-md="center start"
                    >
                        <div class="app-start-date date" fxFlex="0 0 45%" fxLayoutAlign="start center">
                            <mat-form-field fxFlex="0 0 100%">
                                <input
                                    matInput
                                    formControlName="application_start_date"
                                    [ngxMatDatetimePicker]="applicationStartDate"
                                    (focus)="applicationStartDate.open()"
                                    placeholder="Enrollment/Registration start date"
                                    i18n-placeholder="@@enrollment/registrationStartDate"
                                    [max]="occasion.value.start_date"
                                    data-testid="admin-application-start-date"
                                />
                                <mat-datepicker-toggle
                                    matSuffix
                                    [for]="$any(applicationStartDate)"
                                ></mat-datepicker-toggle>
                                <ngx-mat-datetime-picker
                                    closeOnDateSelect
                                    [defaultTime]="[8, 0]"
                                    color="primary"
                                    #applicationStartDate
                                >
                                    <ng-template>
                                        <span>Done</span>
                                    </ng-template>
                                </ngx-mat-datetime-picker>
                            </mat-form-field>
                        </div>

                        <div class="app-end-date date" fxFlex="0 0 45%" fxLayoutAlign="start center">
                            <mat-form-field fxFlex="0 0 100%">
                                <input
                                    matInput
                                    formControlName="application_end_date"
                                    [ngxMatDatetimePicker]="applicationEndDate"
                                    (focus)="applicationEndDate.open()"
                                    placeholder="End date"
                                    i18n-placeholder="@@endDate"
                                    [min]="occasion.value.application_start_date"
                                    [max]="occasion.value.end_date"
                                    data-testid="admin-application-end-date"
                                />
                                <mat-datepicker-toggle
                                    matSuffix
                                    [for]="$any(applicationEndDate)"
                                ></mat-datepicker-toggle>
                                <ngx-mat-datetime-picker
                                    closeOnDateSelect
                                    [defaultTime]="[17, 0]"
                                    color="primary"
                                    #applicationEndDate
                                >
                                    <ng-template>
                                        <span>Done</span>
                                    </ng-template>
                                </ngx-mat-datetime-picker>
                            </mat-form-field>
                        </div>

                        <button
                            [disabled]="occasion.disabled"
                            class="add-date-btn duplicate"
                            color="primary"
                            mat-icon-button
                            (click)="addDate(i)"
                            matTooltip="Duplicate occasion"
                            i18n-matTooltip
                        >
                            <mat-icon class="material-icons-outlined">content_copy</mat-icon>
                        </button>
                    </div>
                    <div
                        class="date-row-wrapper application-period active-occasion w-100 extra seats-location-wrapper"
                        [ngClass]="{ 'on-the-fly': onTheFly }"
                        fxFlex="100%"
                        fxLayout="row"
                        fxLayout.lt-md="column"
                        fxLayoutAlign="start space-between"
                        fxLayoutAlign.lt-md="center start"
                    >
                        <div fxFlex="0 0 45%" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px">
                            <span *ngIf="!onTheFly" i18n>Occasion seats:</span>
                            <span *ngIf="onTheFly" i18n>Seats:</span>

                            <mat-slide-toggle
                                formControlName="unlimited_seats"
                                matTooltip="Unlimited seats"
                                i18n-matTooltip
                            ></mat-slide-toggle>
                            <span *ngIf="occasion.value.unlimited_seats" i18n>Unlimited</span>
                            <mat-form-field class="occ-seats-field" *ngIf="!occasion.value.unlimited_seats">
                                <input
                                    matInput
                                    fxLayoutAlign="end center"
                                    type="number"
                                    min="0"
                                    placeholder="Total seats"
                                    i18n-placeholder
                                    formControlName="total_seats"
                                />
                            </mat-form-field>
                            <button
                                *ngIf="onTheFly"
                                class="fly-expand-btn"
                                color="primary"
                                mat-icon-button
                                (click)="occasion.get('expanded').setValue(!occasion.value.expanded)"
                                matTooltip="Toggle expanded"
                                i18n-matTooltip
                            >
                                <mat-icon>{{ occasion.value.expanded ? 'expand_less' : 'expand_more' }}</mat-icon>
                            </button>
                        </div>
                        <div fxLayout="row" fxFlex="0 0 45%" fxLayoutAlign="start center" fxLayoutGap="28px">
                            <mat-form-field fxFlex="0 0 100%">
                                <input
                                    matInput
                                    fxLayoutAlign="end center"
                                    type="text"
                                    placeholder="Location"
                                    i18n-placeholder="@@location"
                                    formControlName="location"
                                />
                            </mat-form-field>
                        </div>

                        <button
                            *ngIf="!onTheFly"
                            class="add-date-btn expand-btn duplicate"
                            color="primary"
                            mat-icon-button
                            (click)="occasion.get('expanded').setValue(!occasion.value.expanded)"
                            matTooltip="More fields to be added"
                            i18n-matTooltip
                        >
                            <mat-icon>{{ occasion.value.expanded ? 'expand_less' : 'expand_more' }}</mat-icon>
                        </button>
                    </div>
                    <div
                        *ngIf="occasion.value.expanded"
                        class="date-row-wrapper application-period active-occasion w-100 expand-wrapper"
                        fxFlex="100%"
                        fxLayout="column"
                        fxLayoutAlign="start space-between"
                        fxLayoutAlign.lt-md="center start"
                    >
                        <mat-form-field fxFlex="0 0 100%">
                            <textarea
                                #targetGroupTextarea
                                matInput
                                placeholder="Set target group"
                                i18n-placeholder="@@targetGroup"
                                minRows="1"
                                maxlength="1000"
                                formControlName="target_group"
                            ></textarea>
                        </mat-form-field>

                        <mat-form-field fxFlex="0 0 100%">
                            <textarea
                                matInput
                                placeholder="Set activity"
                                i18n-placeholder="@@setActivity"
                                minRows="1"
                                maxlength="1000"
                                formControlName="activity"
                            ></textarea>
                        </mat-form-field>
                        <mat-form-field fxFlex="0 0 100%">
                            <textarea
                                matInput
                                placeholder="Other information"
                                i18n-placeholder="@@otherInformation"
                                minRows="1"
                                maxlength="1000"
                                formControlName="other"
                            ></textarea>
                        </mat-form-field>
                        <mat-form-field fxFlex="0 0 100%">
                            <textarea
                                matInput
                                placeholder="GRIB"
                                i18n-placeholder="@@grib"
                                minRows="1"
                                maxlength="1000"
                                formControlName="grib"
                            ></textarea>
                        </mat-form-field>
                    </div>
                </div>
            </ng-container>
        </div>
    </ng-container>
    <div *ngIf="occasionDatesErrors as errors">
        <div *ngFor="let error of errors | keyvalue">
            <div class="error-message" *ngFor="let msg of error.value">{{ msg }}</div>
        </div>
    </div>
</div>
